import { resolvePageConfig } from './lib/resolvePageConfig'
import { wrapPage } from './lib/wrapPage'
import { checkProcessEnv } from '../../helper/process-env-universal'

export function extendsPage(pageConfig, Component) {
  checkProcessEnv()

  pageConfig = resolvePageConfig(pageConfig)

  const TargetComponent = wrapPage(pageConfig, Component)
  TargetComponent.pageConfig = pageConfig
  return TargetComponent
}
